<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Dr McCrory has written historical biographies of M de Cervantes and A. von Humboldt, four novels, several academic texts and essays and has won national and international awards for his poetry. He was also a Fellow of the Royal Geographical Society.</p><br/>
<p style="text-indent: 00em !important;">He took early retirement from his post as Head of Hispanic and Germanic Studies at the American International University in London to focus on 1) creative writing, 2) further study of Eastern Languages, especially Sanskrit, Hindi and Mandarin, as well as of Eastern philosophies and religions, in particular Advaita Vedanta and Buddhism. Donald enjoys studying languages, travel, opera and classical theatre: he currently lives in Spain.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?23b7d75e